export enum GREEN {
  S400 = '#189C08',
  S300 = '#43CC32',
  S100 = '#F0FFF3',
}
